import React from 'react';
import {Link} from 'react-router-dom';

const billingPageLink = <Link to="/billing">billing page</Link>;
const upgradeLink = <Link to="/billing">upgrade</Link>;


export const getCampaignUpgradeVerbiage = ({currentPlan, campaignLimit}) =>
  currentPlan === 'Enterprise' || currentPlan === 'AppSumo'
  ? (
    <span data-testid="campaignUpgradeVerbiageSchedule">
      Your current plan ({currentPlan}) is limited to {campaignLimit} campaigns.
      Schedule a call on the {billingPageLink} to increase your limits.
    </span>
  )
  : (
      <span data-testid="campaignUpgradeVerbiageWithLink">
        Your current plan ({currentPlan}) is limited to {campaignLimit} campaigns. To create additional campaigns you may upgrade your plan at any time by choosing a new plan on the{' '}
        {billingPageLink}.
      </span>
    );

export const getMediaMonthlyLimitUpgradeVerbiage = ({currentPlan, videosPerMonthLimit}) => 
  currentPlan === 'Enterprise' || currentPlan === 'AppSumo'
  ? (
    <span data-testid="mediaMonthlyLimitUpgradeVerbiageSchedule">
      Your current plan ({currentPlan}) is limited to {videosPerMonthLimit} videos per month.
      Schedule a call on the {billingPageLink} to increase your limits.
    </span>
  )
  : (
      <span data-testid="mediaMonthlyLimitUpgradeVerbiage">
        Your current plan ({currentPlan}) is limited to {videosPerMonthLimit} videos per month. To collect additional videos you may upgrade your plan at any time by choosing a new plan on the{' '}
        {billingPageLink}.
      </span>
    );

export const getMediaMonthlyLimitAlertMessageVerbiage = ({currentPlan}) => (
  <span data-testid="mediaMonthlyLimitAlertMessageVerbiage">
    You have reached the limits of the {currentPlan} plan. Please {upgradeLink} your plan to see this video.
  </span>
);

export const getMediaMonthlyLimitAlertHeaderVerbiage = ({ currentPlan, videosPerMonthLimit, mediaTtl }) => {
  const upgradeVerbiage = <span>The good news is you can still see your videos by upgrading on the {billingPageLink}.</span>;
  const planVerbiage = `On the ${currentPlan} plan, you're limited to ${videosPerMonthLimit} videos per month.`;

  return currentPlan === 'Free'
    ? <span data-testid="mediaMonthlyLimitAlertHeaderVerbiageFree">On the {currentPlan} plan, you're limited to {mediaTtl} days of videos. {upgradeVerbiage}</span>
    : <span data-testid="mediaMonthlyLimitAlertHeaderVerbiage">{planVerbiage} {upgradeVerbiage}</span>;
}


// WEBPACK FOOTER //
// ./src/helpers/planUpgradeVerbiage.js